/**
 * Route guard. Wraps a route element; redirects to /login if no user is
 * present, preserving the attempted destination in location state so the
 * login page can send the user back after a successful sign-in.
 */
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../hooks/useAuth";
import type { ReactNode } from "react";

export function RequireAuth({ children }: { children: ReactNode }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="container" style={{ padding: "var(--space-16) 0", textAlign: "center", color: "var(--text-secondary)" }}>
        Loading…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
